import { render, staticRenderFns } from "./EdiAssignTender.vue?vue&type=template&id=067ea1ed"
import script from "./EdiAssignTender.vue?vue&type=script&lang=js"
export * from "./EdiAssignTender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports